import { createAction } from '@mews/framework';
import prefix from '../prefix';

export const APP_LOADER_DISPLAYED = prefix('APP_LOADER_DISPLAYED');
export const APP_LOADER_HIDDEN = prefix('APP_LOADER_HIDDEN');

export function displayAppLoader() {
    return createAction(APP_LOADER_DISPLAYED);
}

export function hideAppLoader() {
    return createAction(APP_LOADER_HIDDEN);
}
